import React from 'react';
import {Popup} from 'semantic-ui-react';
import PropTypes from 'prop-types';

export const StageEvent = ({event, sportImage}) => (
    <div className='--flex' key={`second-line-${event.id}`}>
        {sportImage && <Popup trigger={sportImage} content={event.sport_name}/>}
        <span>
            {event.parent_stage_category_name ?? null}
            {event.parent_stage_category_name ? ' > ' : null}
            {event.stage_category_name ?? null}
            {event.sport_has_court && event.stadium_name ? ` - ${event.stadium_name}` : ''}
        </span>
    </div>
);

StageEvent.propTypes = {
    event: PropTypes.shape({
        id: PropTypes.string.isRequired,
        stadium_name: PropTypes.string,
        sport_name: PropTypes.string,
        sport_has_court: PropTypes.bool,
        parent_stage_category_name: PropTypes.string,
        stage_category_name: PropTypes.string,
    }).isRequired,
    sportImage: PropTypes.element,
};

StageEvent.defaultProps = {
    event: {
        sport_name: null,
        parent_stage_category_name: null,
        stage_category_name: null,
    },
    sportImage: React.createElement('div'),
};

